function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 27,
  r: 27,
  fill: "#FFFBED"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9 8)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F2C118",
  d: "M24.1704187,25.1466825 C22.9507291,26.200341 22.2035895,27.6946204 22.2035895,29.3038443 L22.2035895,29.3740882 L13.3081571,29.3740882 L13.3081571,29.3230017 C13.3081571,27.7584785 12.6568045,26.2450417 11.4562724,25.2424696 C9.30425464,23.4416714 7.93769145,20.7340882 7.93769145,17.7136004 C7.93769145,12.0877024 12.675962,7.57293522 18.3784897,7.91776893 C23.39135,8.22428777 27.4207957,12.3942213 27.5676693,17.4134674 C27.6570706,20.5041991 26.3224365,23.2820261 24.1704187,25.1466825 Z",
  transform: "rotate(180 17.755 18.637)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 8.78,
  height: 2.634,
  x: 13.421,
  y: 5.339,
  fill: "#CD546C",
  transform: "rotate(180 17.811 6.656)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 8.78,
  height: 2.554,
  x: 13.421,
  y: 2.784,
  fill: "#8E9598",
  transform: "rotate(180 17.811 4.061)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#357495",
  d: "M20.7773966,0 C20.6496804,1.55813747 19.3469753,2.78421286 17.7569088,2.78421286 C16.1668423,2.78421286 14.8577514,1.55813747 14.7300352,0 L20.7773966,0 Z",
  transform: "rotate(180 17.754 1.392)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CD546C",
  d: "M14.1490897,19.1763857 C14.3931488,19.3004586 14.6894208,19.2561468 14.8862234,19.0660324 L16.2040229,17.7926661 L17.5219079,19.0660324 C17.7704107,19.306168 18.1653831,19.3062532 18.4138858,19.0660324 L19.7315145,17.7927513 L21.0489722,19.0660324 C21.171429,19.1843107 21.3322551,19.2461768 21.4952175,19.2461768 C21.5941742,19.2461768 21.6939001,19.2233391 21.7861913,19.1764709 C22.0302504,19.0523128 22.1682601,18.7872092 22.129549,18.5167371 L20.6872417,8.44859656 C20.6371652,8.09921547 20.3121803,7.85626778 19.9621572,7.90628893 C19.6117067,7.95622486 19.3682458,8.27995627 19.4183224,8.62933737 L20.5957196,16.8477181 L20.1776743,16.4437142 C19.9290861,16.2034934 19.5341137,16.2034934 19.285611,16.4437142 L17.9679823,17.7169953 L16.6501828,16.443629 C16.4015946,16.2034934 16.0067931,16.2034934 15.7582049,16.443629 L15.3398178,16.8479737 L16.5270423,8.56108023 C16.5770334,8.21161392 16.3335725,7.88796773 15.9832075,7.83803179 C15.6325862,7.78818108 15.3081995,8.03095833 15.258123,8.38033943 L13.8059884,18.5165667 C13.767021,18.787124 13.9049451,19.0522276 14.1490897,19.1763857 Z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#F2C118",
  strokeLinecap: "square",
  transform: "translate(0 11.93)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 15.366,
  x2: 20.634,
  y1: 22.753,
  y2: 22.753,
  transform: "rotate(90 18 22.753)"
}), /*#__PURE__*/React.createElement("line", {
  x1: 25.008,
  x2: 29.205,
  y1: 22.246,
  y2: 18.895,
  transform: "rotate(90 27.106 20.57)"
}), /*#__PURE__*/React.createElement("line", {
  x1: 31.61,
  x2: 33.708,
  y1: 15.334,
  y2: 9.659,
  transform: "rotate(90 32.66 12.497)"
}), /*#__PURE__*/React.createElement("line", {
  x1: 33.366,
  x2: 31.92,
  y1: 5.644,
  transform: "rotate(90 32.643 2.822)"
}), /*#__PURE__*/React.createElement("line", {
  x1: 4.391,
  x2: 2.945,
  y1: 5.644,
  transform: "rotate(118.367 3.668 2.822)"
}), /*#__PURE__*/React.createElement("line", {
  x1: 2.634,
  x2: 4.733,
  y1: 15.334,
  y2: 9.659,
  transform: "rotate(49.707 3.684 12.497)"
}), /*#__PURE__*/React.createElement("line", {
  x1: 6.569,
  x2: 10.766,
  y1: 22.246,
  y2: 18.895,
  transform: "rotate(-12.399 8.667 20.57)"
}))));

function SvgSpotlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotlight);
export default __webpack_public_path__ + "static/media/spotlight.bd8240c3.svg";
export { ForwardRef as ReactComponent };